// Statement windows are [from, to): the "to" day is included by asking for
// the start of the following local day.
export function statementRange(fromDay: string, toDay: string): { from: string; to: string } {
  const from = new Date(`${fromDay}T00:00:00`);
  const to = new Date(`${toDay}T00:00:00`);
  to.setDate(to.getDate() + 1);
  return { from: from.toISOString(), to: to.toISOString() };
}
